export default "__VITE_ASSET__DCMgKvwA__"